import { registerPlugin } from '@capacitor/core';

export interface TikTokSdkPlugin {
  /**
   * Track a custom event
   */
  trackEvent(options: TikTokTrackEventOptions): Promise<void>;

  /**
   * Set user properties for targeting
   */
  setUserProperties(options: TikTokUserPropertiesOptions): Promise<void>;

  /*
   * Logout the user
   */
  logout(): Promise<void>;
}

export interface TikTokTrackEventOptions {
  /**
   * The name of the event to track
   */
  eventName: string;

  /**
   * Additional properties for the event
   */
  properties?: Record<string, unknown>;
}

export interface TikTokUserPropertiesOptions {
  /**
   * User ID
   */
  userId: string;

  /**
   * User email
   */
  email?: string;

  /**
   * User phone number
   */
  phone?: string;
}

export default registerPlugin<TikTokSdkPlugin>('TikTokSdk');
